import React from 'react'
import CustomDialog from './CustomDialog'
import { FaSave } from "react-icons/fa";

const SiteSelectionDialog = ({
  open,
  sites = [],
  selectedSites = [],
  onToggleSite,
  onCancel,
  onSave,
  isSaving = false,
  isMobile = false,
}) => {

  const handleToggle = (siteId) => (event) => {
    onToggleSite?.(siteId, event.target.checked)
  }

  const selectionEmpty = !selectedSites?.length
  const hasSites = Array.isArray(sites) && sites.length > 0

  return (
    <CustomDialog open={open} padding={0} width={520} isMobile={isMobile}>
      <div className="w-full rounded-2xl bg-white p-6 text-customPrimaryText shadow-2xl shadow-customAccent/10 dark:bg-customSurface dark:text-customHeading">
        <header className="mb-4">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-customAccent">Multi-site save</p>
          <h3 className="mt-1 text-xl font-semibold text-customInk dark:text-customHeading">
            Save betting data across sites
          </h3>
          <p className="mt-2 text-sm text-customSecondaryText dark:text-customMuted">
            Please select sites that you want to save betting data also.
          </p>
        </header>

        <div className="grid gap-3">
          {hasSites ? (
            sites.map((site) => {
              const checked = selectedSites?.includes(site.id)
              return (
                <label
                  key={site.id}
                  className={`flex cursor-pointer items-start gap-3 rounded-2xl border px-4 py-3 text-sm transition ${
                    checked
                      ? 'border-customAccent bg-customSlate shadow-md shadow-customAccent/10 dark:border-customAccent/60 dark:bg-customSurfaceMuted'
                      : 'border-customAccent/15 bg-customSlate/60 hover:border-customAccent/40 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/60'
                  }`}
                >
                  <input
                    type="checkbox"
                    className="mt-1 h-4 w-4 rounded border-customAccent/30 text-customAccent focus:ring-customAccent"
                    checked={checked}
                    onChange={handleToggle(site.id)}
                  />
                  <div>
                    <p className="font-semibold text-customInk dark:text-customHeading">{site.label}</p>
                    {site.description ? (
                      <p className="text-xs text-customSecondaryText dark:text-customMuted">{site.description}</p>
                    ) : null}
                  </div>
                </label>
              )
            })
          ) : (
            <p className="rounded-xl border border-dashed border-customAccent/30 bg-customSlate/40 px-4 py-6 text-center text-sm text-customSecondaryText dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/40 dark:text-customMuted">
              No site options were provided.
            </p>
          )}
        </div>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            disabled={isSaving}
            className="rounded-xl border border-customAccent/30 px-4 py-2 text-sm font-semibold text-customAccent transition hover:bg-customAccent/10 focus:outline-none focus:ring-2 focus:ring-customAccent/30 disabled:cursor-not-allowed disabled:opacity-60 dark:text-customHeading"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={isSaving || selectionEmpty}
            className="flex items-center justify-center gap-2 rounded-xl bg-customAccentBlue px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-customAccentBlue/30 transition hover:bg-customAccentBlue/90 focus:outline-none focus:ring-2 focus:ring-customAccentBlue/40 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-customAccent"
          >
            {isSaving ? (
              <>
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                Saving...
              </>
            ) : (
              <>
                <FaSave size={15}/>
                Save betting
              </>
            )}
          </button>
        </div>
      </div>
    </CustomDialog>
  )
}

export default SiteSelectionDialog
